import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './Pages/Home'
import Contact from './Pages/Contact'
import About from './Pages/About'
import Terms from './Pages/Terms'
import Policy from './Pages/Policy'
import Search from './Pages/Search'
import Intent from './Pages/Intent'
import EventDetails from './Pages/Event'
import Payment from './Pages/Payment'
import ScanTicket from './Pages/Scan_Ticket'
import Upcomingevents from './Pages/Upcoming'
import Trendingevents from './Pages/Trending'


const Router = () => {
  return (
    <BrowserRouter key="main-router">
      <Routes >
        <Route  path='/' element={<Home />} />
        <Route  path='/:eventId' element={<Home />} />
        <Route  path='/contact' element={<Contact />} />
        <Route  path='/about' element={<About />} />
        <Route  path='/terms' element={<Terms />} />
        <Route  path='/policy' element={<Policy />} />
        <Route  path='/upcoming' element={<Upcomingevents />} />
        <Route  path='/trending' element={<Trendingevents />} />
        <Route  path='/search' element={<Search />} />
        <Route  path='/verify' element={<Payment />} />
        <Route  path='/intent/search' element={<Intent />} />
        <Route  path='/event/:eventId' element={<EventDetails />} />
        <Route  path='/scan-ticket/:ticketId' element={<ScanTicket />} />
      </Routes>
    </BrowserRouter>
  )
  
}

export default Router
